import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../services/contact.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() showCertificates = true;
  footerForm: FormGroup;
  apiErrors: string[] = [];
  isMessageSent: boolean = false;

  constructor(
    private fb: FormBuilder,
    private _contactService: ContactService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.footerForm = this.fb.group({
      name: this.fb.control('', [Validators.required]),
      email: this.fb.control('', [Validators.required, Validators.email]),
      message: this.fb.control('', [Validators.required]),
      consentToElectronicCommunications: this.fb.control(false, [Validators.requiredTrue]),
    });
  }

  public sendMessage() {
    this.apiErrors = [];
    this.isMessageSent = false;
    if (this.footerForm.invalid) {
      this.footerForm.markAllAsTouched();
      return;
    }

    const values = this.footerForm.getRawValue();
    const [name, lastName] = values.name.split(' ');
    const payload = {
      name: name,
      lastName: lastName || null,
      email: values.email,
      message: values.message,
      consentToElectronicCommunications:
        values.consentToElectronicCommunications,
    };
    if (isPlatformBrowser(this.platformId)) {
      this._contactService.sendMessage(payload).subscribe(
        (data) => {
          this.footerForm.reset();
          this.isMessageSent = true;
        },
        (error) => {
          this.isMessageSent = false;
          this.apiErrors = error.error.errors.map(
            ({ slug }: { slug: string }) => slug,
          );
        },
      );
    }

  }
}
